import _Close from "@mui/icons-material/Close";
import { IconButton } from '@mui/material';
import { SIZES } from '@fupa/fupa-uikit';
import React from 'react';
import { styled } from '@mui/material/styles';
const StyledIconButton = styled(IconButton)(_ref => {
  let {
    isDesktop
  } = _ref;
  return {
    top: 0,
    left: 0,
    marginTop: "calc(".concat(SIZES['16'], " + env(safe-area-inset-top))"),
    marginLeft: "calc(".concat(isDesktop ? SIZES['32'] : SIZES['16'], " + env(safe-area-inset-left))"),
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }
  };
});
const CloseButton = _ref2 => {
  let {
    handleClick,
    isDesktop
  } = _ref2;
  return /*#__PURE__*/React.createElement(StyledIconButton, {
    size: "large",
    isDesktop: isDesktop,
    onClick: handleClick,
    "data-sentry-element": "StyledIconButton",
    "data-sentry-component": "CloseButton",
    "data-sentry-source-file": "CloseButton.tsx"
  }, /*#__PURE__*/React.createElement(_Close, {
    color: "icon-invert",
    "data-sentry-element": "Close",
    "data-sentry-source-file": "CloseButton.tsx"
  }));
};
export default CloseButton;